import { Box, Button, Paper } from '@mui/material';
import { inject, observer } from 'mobx-react';
import KeyboardDoubleArrowLeft from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRight from '@mui/icons-material/KeyboardDoubleArrowRight';
import ReactComponent from '../ReactComponent';
import ModalDetalhesProcesso from './ModalDetalhesProcesso';
import PainelDetalhes from './PainelDetalhes';
import PainelProcessos from './PainelProcessos';
import { action, computed, makeObservable } from 'mobx';
import { createRef } from 'react';

class PainelProcessosDetalhes extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            inicializaExibicaoPainel: action,
            toggleMostrarPainelProcessosDetalhes: action,
            mensagemInformativaToggle: computed
        });

        this.selectorRef = createRef();
        this.inicializaExibicaoPainel();
    }

    inicializaExibicaoPainel() {
        this.appStore.mostrarPainelProcessosDetalhes = true;
    }

    toggleMostrarPainelProcessosDetalhes = () => {
        this.appStore.mostrarPainelProcessosDetalhes = !this.appStore.mostrarPainelProcessosDetalhes;
    };

    get mensagemInformativaToggle() {
        return this.appStore.mostrarPainelProcessosDetalhes
            ? 'Ocultar painel de listagem de processos.'
            : 'Exibir painel de listagem de processos.';
    }

    render() {
        return (
            <div style={{ display: 'flex', flexGrow: '1', margin: '5px', position: 'relative' }}>
                {this.renderPainelProcessos()}
                <Paper
                    style={{ display: 'flex', flexGrow: 1, width: '57%' }}
                    elevation={4}
                >
                    <PainelDetalhes />
                </Paper>
                <ModalDetalhesProcesso />
            </div>
        );
    }

    renderPainelProcessos() {
        return (
            <Box
                sx={{
                    display: 'flex',
                    position: this.appStore.mostrarPainelProcessosDetalhes ? 'relative' : 'absolute',
                    left: this.appStore.mostrarPainelProcessosDetalhes
                        ? '0px'
                        : `-${this.selectorRef?.current?.clientWidth + 20}px`,
                    height: '100%'
                }}
            >
                {this.routerStore.isPreSessao ? (
                    <Paper
                        ref={this.selectorRef}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            flexGrow: 1,
                            width: '510px',
                            marginRight: '5px'
                        }}
                        elevation={4}
                    >
                        <PainelProcessos />
                    </Paper>
                ) : (
                    <Paper
                        ref={this.selectorRef}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            flexGrow: 1,
                            width: '700px',
                            marginRight: '5px'
                        }}
                        elevation={4}
                    >
                        <PainelProcessos />
                    </Paper>
                )}
                <Button
                    variant="contained"
                    onClick={this.toggleMostrarPainelProcessosDetalhes}
                    size="small"
                    title={this.mensagemInformativaToggle}
                    aria-label={this.mensagemInformativaToggle}
                    sx={{
                        position: 'absolute',
                        zIndex: 999,
                        top: '50%',
                        right: this.appStore.mostrarPainelProcessosDetalhes ? '-15px' : '-30px',
                        minWidth: 'auto',
                        width: '25px'
                    }}
                >
                    {this.appStore.mostrarPainelProcessosDetalhes ? (
                        <KeyboardDoubleArrowLeft />
                    ) : (
                        <KeyboardDoubleArrowRight />
                    )}
                </Button>
            </Box>
        );
    }
}

export default inject('stores')(observer(PainelProcessosDetalhes));
